import { render, staticRenderFns } from "./commit_block.vue?vue&type=template&id=7f408e5a&"
import script from "./commit_block.vue?vue&type=script&lang=js&"
export * from "./commit_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "commit_block.vue"
export default component.exports